var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","sm6":"","md4":"","xl4":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.langC.InProgress))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }